// extracted by mini-css-extract-plugin
module.exports = {"SectionGraphCompare":"SectionGraphCompare_SectionGraphCompare__I8ADY"};